import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../utils/fetchFilterData";
import { itemsPerPageValue } from "../../../utils/ItemsPerPageValue";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import ItemsPerPageSelect from "../../elements/filter/ItemsPerPageSelect";
import Notification from "../../elements/notification/Notification";
import FeeFilter from "../../clients/admin/fee/FeeFilter";
import FilterAppliedList from "../../elements/filter/FilterAppliedList";
import DefaultFeeList from "./DefaultFeeList";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import MaterialPagination from "../../styles/materialPagination";
import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledFeeWrapper } from "../../fee/styledFee";

const DefaultFeeContainer = ({ match }) => {
  const { t } = useTranslation("defaultFeePage");

  const [fees, setFees] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "baseFee.service.name": checkFilterItem(history, "baseFee.service.name", null),
    "baseFee.paymentSystem.name": checkFilterItem(history, "baseFee.paymentSystem.name", null),
    "baseFee.currency.asset": checkFilterItem(history, "baseFee.currency.asset", null),
    "baseFee.type": checkFilterItem(history, "baseFee.type", null),
    "percent[gte]": checkFilterItem(history, "percent[gte]", null, true),
    "percent[lte]": checkFilterItem(history, "percent[lte]", null, true),
    "constant[gte]": checkFilterItem(history, "constant[gte]", null, true),
    "constant[lte]": checkFilterItem(history, "constant[lte]", null, true),
    "min[gte]": checkFilterItem(history, "min[gte]", null, true),
    "min[lte]": checkFilterItem(history, "min[lte]", null, true),
    "max[gte]": checkFilterItem(history, "max[gte]", null, true),
    "max[lte]": checkFilterItem(history, "max[lte]", null, true)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchDefaultFees = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/default-fees" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setFees(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchDefaultFees();
  }, [filterData]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledFeeWrapper>
          <div className="admin-filter">
            <FeeFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <DefaultFeeList
            fees={fees}
            fetchDefaultFees={fetchDefaultFees}
            notification={notification}
            setNotification={setNotification}
          />
          {totalPageCount > 0 &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledFeeWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default DefaultFeeContainer;